<template>
  {{#if @isSelected}}
    <blockquote>
      <div class="_quotemark">
        &ldquo;
      </div>
      <p class="_quote">
        {{@quote}}
      </p>
      <div class="_attribution">
        <div>
          <p><strong>{{@author}}</strong></p>
          <p>{{@title}}</p>
          <p>{{@school}}</p>
        </div>
      </div>
    </blockquote>
  {{/if}}
</template>
